import React, {useEffect, useState} from "react";
import {createRoot} from "react-dom/client";
import 'dayjs/locale/fr'
import Handlebars from "handlebars";
import "./i18n";
import "./index.css";
import dayjs from 'dayjs';
import * as Sentry from "@sentry/react";

const DynamicAppLoader = () => {
    const [App, setApp] = useState<React.ElementType | null>(null);

    useEffect(() => {
        const loadApp = async () => {
            let appModule;
            if (import.meta.env.VITE_APP_MODE === 'backoffice') {
                appModule = await import("./backoffice/App");
            } else if (import.meta.env.VITE_APP_MODE === 'trainee') {
                appModule = await import("./trainee/App");
            }
            setApp(() => appModule.default);
        };

        loadApp();
    }, []);

    if (!App) return <div>Loading...</div>;

    return <App />;
};

if (import.meta.env.VITE_USE_SENTRY == "true") {
    Sentry.init({
      dsn: "https://rDNbytw9mefPGZWaFYevUgjq@s2653136.eu-central-1a.betterstackdata.com/2653136",
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
        Sentry.captureConsoleIntegration({ levels: ["error"] }),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/trainee\.gtf-gest\.fr/],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  }

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);
dayjs.locale('fr');

Handlebars.registerHelper('ifEq', function (arg1, arg2, options) {
    return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
});
Handlebars.registerHelper('ifNotEq', function (arg1, arg2, options) {
    return (arg1 != arg2) ? options.fn(this) : options.inverse(this);
});

// After Sentry.init so captureConsole can wrap console.error first.
// Do not stub console.error / console.warn — Sentry depends on them.
if (import.meta.env.PROD) {
    console.log = () => {};
}

root.render(
    //<React.StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Une erreur est survenue.</p>}>
        <React.Suspense fallback="loading">
            <DynamicAppLoader />
        </React.Suspense>
    </Sentry.ErrorBoundary>
    //</React.StrictMode>
);
